export const LEGAL_IMPRINT_LEGAL_NOTICE: string = `

### Imprint / Legal Notice - English

<!-- for (const addressLine of context.company.address) { -->
<!--= addressLine -->
<!-- } -->

Phone / WhatsApp Business: <!--= context.company.phone -->
E-mail: <!--= context.company.mail -->

Managing Director(s)
<!-- for (const director of context.company.directors) { -->
<!--= director -->
<!-- } -->

Register Court: <!--= context.company.court -->
Register Number: <!--= context.company.courtNumber -->

Value Added Tax Identification Number (VAT ID):  <!--= context.company.vat -->

#### Understanding Our Legal Notice

The legal notice section, also known as “Imprint” in English or “Impressum” in German, contains important information about our website, including details about the company, contact information, and legal obligations. It ensures transparency, compliance with applicable laws, and facilitates effective communication. Please read this section to learn more about our legal identity and responsibilities.
`;
